let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iejsf")).then(() => parcelRequire('byyza'));